import { germanLabels } from "translations/de";
import { TranslationLabels } from "translations/TranslationLabels";

export const ResourceKeys = Object.fromEntries(Object.keys(germanLabels).map((k) => [k, k])) as {
  [K in keyof TranslationLabels]: K;
};

/**
 * The union of every valid translation-resource key string.
 * Use this type instead of `string` wherever a resource key is expected,
 * so TypeScript enforces that only keys defined in TranslationLabels are passed.
 * At runtime the values are identical to the key names (see ResourceKeys object above).
 */
export type ResourceKey = keyof TranslationLabels;
